// Action Types
const SET_CLOUD_PROVIDER = "SET_CLOUD_PROVIDER";
const GET_CLOUD_PROVIDER = "GET_CLOUD_PROVIDER";

// Action Creators
export const setCloudProvider = (provider) => ({
  type: SET_CLOUD_PROVIDER,
  provider,
});

export const getCloudProvider = () => ({
  type: GET_CLOUD_PROVIDER,
});

// Initial State
const initialState = {
  selectedProvider: localStorage.getItem("selectedCloudProvider") || "azure",
};

// Reducer
export function CloudProviderStore(state = initialState, action) {
  switch (action.type) {
    case SET_CLOUD_PROVIDER:
      localStorage.setItem("selectedCloudProvider", action.provider);
      return {
        ...state,
        selectedProvider: action.provider,
      };
    case GET_CLOUD_PROVIDER:
      return state;
    default:
      return state;
  }
}

export { SET_CLOUD_PROVIDER, GET_CLOUD_PROVIDER };
